import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import classnames from 'classnames';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import SnackbarContent from '@material-ui/core/SnackbarContent';

import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';

import styles from './styles';

const variantIcons = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon
};

class AlertPanel extends React.Component {
    render() {
        const { classes, className, message, onClose, variant, ...other } = this.props;

        const Icon = variantIcons[variant];

        return (
            <SnackbarContent
                elevation={0}
                className={classnames(classes.root, classes[variant], className)}
                {...other}
                message={
                    <span id="alert-panel" className={classes.message}>
                        <Icon className={classnames(classes.icon, classes.iconVariant)} />
                        {message}
                    </span>
                }
            />
        );
    }
}

AlertPanel.propTypes = {
    className: PropTypes.string,
    message: PropTypes.string.isRequired,
    onClose: PropTypes.func,
    variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']),
};

export default withStyles(styles)(AlertPanel);